import React from 'react';
import ToolTip from 'components/common/tool-tip-component';
import classnames from 'classnames';
import { ReactComponent as CloseButton } from 'icons/close-button.svg';
import { ReactComponent as AutoTieoutUnlinkIcon } from 'icons/auto-tieout-unlink.svg';

const LINKED_STATEMENT_CANCEL_ICON = 'linked-statement-cancel-icon';
const CLOSE_ICON_SIZE = 25;
const UNLINK_ICON_SIZE = 30;

const LinkedStatementCancelIcon = ({
  isIconDisabled,
  colId,
  isAutoTieoutInProgress,
  onUnlinkIconClick,
  onCancelIconClick,
  rowData,
  isCurrentStatementWrappedUp,

}) => {
  const getTooltipText = () => {
    if (isAutoTieoutInProgress) {
      return 'auto-tieout.linked-statements.table.column.cancel.tooltip.message';
    }
    if (isCurrentStatementWrappedUp) {
      return 'auto-tieout.linked-statements.table.column.unlink.wrappedup.tooltip.message';
    }
    return 'auto-tieout.linked-statements.table.column.unlink.tooltip.message';
  };

  return (
    <div className={LINKED_STATEMENT_CANCEL_ICON}>
      <ToolTip key={colId} id={colId} text={getTooltipText()}>
        <div
          className={classnames({
            'unlink-icon': !isIconDisabled,
            'unlink-icon-wrap': isIconDisabled,
          })}
          onMouseEnter={(e) => {
            e.stopPropagation();
            // Hide any tooltips from parent elements
            const tooltips = document.querySelectorAll('[role="tooltip"]');
            tooltips.forEach((tooltip) => {
              if (!tooltip.id.includes(colId)) {
                tooltip.style.display = 'none';
              }
            });
          }}
          onMouseLeave={() => {
            // Re-enable tooltips when leaving unlink icon
            const tooltips = document.querySelectorAll('[role="tooltip"]');
            tooltips.forEach((tooltip) => {
              tooltip.style.display = '';
            });
          }}
        >
          {isAutoTieoutInProgress ? (
            <CloseButton
              className={`cancelBtn`}
              onClick={(e) => onCancelIconClick(e, rowData)}
              height={CLOSE_ICON_SIZE}
              width={CLOSE_ICON_SIZE}
              role="button"
            />
          ) : (
            <AutoTieoutUnlinkIcon
              width={UNLINK_ICON_SIZE}
              height={UNLINK_ICON_SIZE}
              onClick={(e) => {
                e.stopPropagation();
                !isIconDisabled && onUnlinkIconClick(e, rowData);
              }}
              disabled={isIconDisabled}
            />
          )}
        </div>
      </ToolTip>
    </div>
  );
};
export default LinkedStatementCancelIcon;
